module.exports = __webpack_public_path__ + "static/media/cascada-la-periquera-360-preview.c34353d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/360photos/cascada-la-periquera-360-preview.jpg
// module id = 1157
// module chunks = 0